// extracted by mini-css-extract-plugin
module.exports = {"loader":"loader_loader_2-l8m","spin":"loader_spin_W0uoX","loaderContainer":"loader_loaderContainer_1dsU4"};